module.exports = __webpack_public_path__ + "static/media/Logo_Dark.ab5a54d7.png";